'use client';

import { useEffect } from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { AdminDataTable } from '../components/AdminDataTable';
import { StatusBadge } from '../components/StatusBadge';
import type { AdminReminderRow } from '../context/AdminAllDataContext';
import { useAdminAllData } from '../context/AdminAllDataContext';
import { Button } from '@/core/presentation/components/ui/Button';
import { Plus } from 'lucide-react';

const columns = [
  { key: 'id', header: 'ID' },
  {
    key: 'userDisplayName',
    header: 'Usuário',
    render: (r: AdminReminderRow) => r.userDisplayName,
  },
  {
    key: 'clientDisplayLabel',
    header: 'Cliente',
    render: (r: AdminReminderRow) => r.clientDisplayLabel,
  },
  {
    key: 'serviceDisplayLabel',
    header: 'Serviço',
    render: (r: AdminReminderRow) => r.serviceDisplayLabel,
  },
  { key: 'expected_date', header: 'Data esperada' },
  {
    key: 'sent_at',
    header: 'Envios',
    render: (r: AdminReminderRow) => r.sent_at.length,
  },
  {
    key: 'status',
    header: 'Status',
    render: (r: AdminReminderRow) => <StatusBadge status={r.status} />,
  },
];

export default function RemindersPage() {
  const {
    state: {
      enrichedReminders,
      usersLoading,
      servicesLoading,
      remindersLoading,
      usersError,
      servicesError,
      remindersError,
    },
    events: { refreshAll },
  } = useAdminAllData();

  useEffect(() => {
    void refreshAll();
  }, [refreshAll]);

  const loadingInitial =
    (usersLoading || servicesLoading || remindersLoading) && enrichedReminders.length === 0;
  const errorMessage = usersError ?? servicesError ?? remindersError;

  return (
    <div>
      <SectionHeader
        title="Lembretes"
        subtitle="Controle e acompanhamento de lembretes enviados"
        actions={
          <Button className="bg-admin-navy hover:bg-admin-navy-mid text-white">
            <Plus className="h-4 w-4 mr-1" />
            Novo lembrete
          </Button>
        }
      />
      {errorMessage ? (
        <p className="text-sm text-destructive mb-4" role="alert">
          {errorMessage}
        </p>
      ) : null}
      {loadingInitial ? (
        <p className="text-sm text-admin-text-secondary py-8">Carregando lembretes…</p>
      ) : (
        <AdminDataTable
          data={enrichedReminders}
          columns={columns}
          searchKeys={[
            'id',
            'userDisplayName',
            'clientDisplayLabel',
            'serviceDisplayLabel',
            'status',
            'expected_date',
          ]}
        />
      )}
    </div>
  );
}
